import { BigNumber } from "bignumber.js";

import { nesaTestnet } from "app/config/chains";

export const getFormattedNumber = (value?: number | string) => {
  const numValue = Number(value);
  if (!value || Number.isNaN(numValue)) return "";

  return numValue.toLocaleString("en-US");
};

export const getFormattedTxFee = (value: number | string, desiredDecimals = 6) => {
  if (!value) return "";
  if (nesaTestnet.feeCurrencies[0].coinDecimals === desiredDecimals) return value;

  const divideBy =
    BigInt(10) ** BigInt(nesaTestnet.feeCurrencies[0].coinDecimals - desiredDecimals);
  // @ts-expect-error 2362, 2363
  const numValue = BigNumber(value) / BigNumber(divideBy);

  // @ts-expect-error 2345
  return BigNumber(numValue).toFixed(BigNumber(numValue).decimalPlaces()).toLocaleString();
};

export function decimal2percent(v?: string) {
  return v ? parseFloat((Number(v) * 100).toFixed(2)) : "";
}
